import { createHttpClient } from "@intergamma/account"
import type { PromotionProduct } from "../base-api/generated"

export function createPromotionsService(MYACCOUNT_URL: string) {
  const promotionsClient = createHttpClient(`${MYACCOUNT_URL}/api/promotions`, {
    withCredentials: true,
  })

  return {
    getProducts(language: string): Promise<PromotionProduct[]> {
      return promotionsClient.get<PromotionProduct[]>("/products", {
        headers: { "Accept-Language": language },
      })
    },
  }
}
